export const InfoIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2474_1497)">
      <path d="M9.1665 5.83335H10.8332V7.50002H9.1665V5.83335ZM9.1665 9.16669H10.8332V14.1667H9.1665V9.16669ZM9.99984 1.66669C5.39984 1.66669 1.6665 5.40002 1.6665 10C1.6665 14.6 5.39984 18.3334 9.99984 18.3334C14.5998 18.3334 18.3332 14.6 18.3332 10C18.3332 5.40002 14.5998 1.66669 9.99984 1.66669ZM9.99984 16.6667C6.32484 16.6667 3.33317 13.675 3.33317 10C3.33317 6.32502 6.32484 3.33335 9.99984 3.33335C13.6748 3.33335 16.6665 6.32502 16.6665 10C16.6665 13.675 13.6748 16.6667 9.99984 16.6667Z" />
    </g>
    <defs>
      <clipPath id="clip0_2474_1497">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
